// extracted by mini-css-extract-plugin
export default {"connector":"EntityModulesSettings_connector__2wGmj"};